import { TimerOutlineIcon } from './TimerOutlineIcon';

/**
 * author: Google
 * id 017E0965-CD2E-4B39-B0C5-410335848B12
 * name timer-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-outline.svg
 * tags
 * - Date / Time 
 * - Sport 
 */
export const StopwatchOutlineIcon = TimerOutlineIcon;
export default StopwatchOutlineIcon